import { ReferenceCreatedByFields } from 'drapcode-constant';
import { getFieldOptionsForSelect } from '../pluginComponentApi';

const textComponentsForJsonField = ['header', 'text', 'paragraph'];
const linkComponentsForJsonField = ['link', 'link-box', 'image'];
const formInputComponentsForJsonField = ['input'];
const mediaComponentsForJsonField = ['bs-image'];

export default function (editor, opt = {}) {
  const traitManager = editor.TraitManager;
  const { collectionOptions } = opt;
  const style = document.createElement('style');
  style.innerHTML = `
        .checkmark::after {
            left: 4px;
            top: 4px;
        }
        checkbox{
        all:unset;
        }
       
        select option:first-child {
            color: grey;
        }
        select.empty {
            color: grey;
        }
        select option[disabled]:first-child {
            display: none;
        }
        .input[type=data-group-text] {
            display:none;
        }
        .width100{
          width: 100%;
        }
  `;
  document.head.appendChild(style);
  traitManager.addType('data-group-field-src', {
    createInput({ trait }) {
      const options = trait.get('options') || [];
      const el = document.createElement('div');
      el.classList.add('custom-field');
      el.innerHTML = `    
    <div id="URL">
    <div class="form-group">
    <label>
                    <input type="checkbox" name="getSrcFrom"
                           style="all: revert;"/>
                    Get Image From ${trait.get('collectionTitle')}
                </label>
      
    </div>
    <div class="form-group">
         <div id="select-field-div" style="display: none">
               <select class="selectField form-control form-control-sm options-light">
                   
               </select>
         </div>
     </div>
    </div>
    `;
      // const radioButton = el.querySelector("input[name=getTextFrom]");
      const checkbox = el.querySelector('input[type=checkbox][name="getSrcFrom"]');
      const selectFieldDiv = el.querySelector('#select-field-div');
      const selectField = el.querySelector('.selectField');
      checkbox.addEventListener('click', async (ev) => {
        if (ev.target.checked) {
          selectField.innerHTML = getFieldOptionsForSelect(options);
          selectFieldDiv.style.display = 'block';
        } else {
          selectFieldDiv.style.display = 'none';
        }
      });
      return el;
    },
    onEvent({ elInput, component }) {
      onTraitsChange(elInput, component, this.model);
    },
    onUpdate({ elInput, component }) {
      onTraitsUpdate(elInput, component, this.model);
    },
  });
  traitManager.addType('data-group-field-uuid', {
    onEvent({ elInput, component }) {
      onTraitsChange(elInput, component, this.model);
    },
    onUpdate({ elInput, component }) {
      onTraitsUpdate(elInput, component, this.model);
    },
  });
  traitManager.addType('data-group-field', {
    createInput({ trait }) {
      const options = trait.get('options') || [];
      const el = document.createElement('div');
      el.classList.add('custom-field');
      el.innerHTML = `    
    <div id="URL">
    <div class="form-group">
    <label>
                    <input type="checkbox" name="getTextContent"
                           style="all: revert;"/>
                    ${trait.get('title')}
                </label>
      
    </div>
    <div class="form-group">
         <div id="field-text-select-div" style="display: none">
               <select class="field-text-select form-control form-control-sm options-light">
                   
               </select>
         </div>
     </div>
    </div>
    `;
      // const radioButton = el.querySelector("input[name=getTextFrom]");
      const checkbox = el.querySelector('input[type=checkbox][name="getTextContent"]');
      const selectFieldDiv = el.querySelector('#field-text-select-div');
      const selectField = el.querySelector('.field-text-select');
      checkbox.addEventListener('click', async (ev) => {
        if (ev.target.checked) {
          selectField.innerHTML = getFieldOptionsForSelect(options);
          selectFieldDiv.style.display = 'block';
        } else {
          selectFieldDiv.style.display = 'none';
        }
      });
      return el;
    },
    onEvent({ elInput, component }) {
      onTraitsChange(elInput, component, this.model);
    },
    onUpdate({ elInput, component }) {
      onTraitsUpdate(elInput, component, this.model);
    },
  });

  traitManager.addType('data-group-href-field', {
    createInput({ trait }) {
      const options = trait.get('options') || [];
      const el = document.createElement('div');
      el.classList.add('custom-field');
      el.innerHTML = `    
      <div id="URL">
      <div class="form-group">
        <label>
          <input type="checkbox" name="getURLFrom" style="all: revert;" />
          ${trait.get('title')}
        </label>
      </div>
      <div class="form-group">
         <div id="field-url-select-div" style="display: none">
               <select class="field-url-select form-control form-control-sm options-light">
                   
               </select>
         </div>
     </div>
    </div>
    `;
      const checkbox = el.querySelector('input[type=checkbox][name="getURLFrom"]');
      const selectFieldDiv = el.querySelector('#field-url-select-div');
      const selectField = el.querySelector('.field-url-select');
      checkbox.addEventListener('click', async (ev) => {
        console.log('getURLFrom ev::::', ev, 'options::::', options);
        if (ev.target.checked) {
          selectField.innerHTML = '';
          let optionHtml = `<option value="" selected>- Select One -</option>
                              <option value="" >None</option>`;
          optionHtml += `${options
            .map((opt) => `<option value="${opt.id}">${opt.name}</option>`)
            .join('')}`;
          selectField.innerHTML = optionHtml;
          selectFieldDiv.style.display = 'block';
        } else {
          selectFieldDiv.style.display = 'none';
        }
      });
      return el;
    },
    onEvent({ elInput, component }) {
      onLinkTraitsChange(elInput, component, this.model);
    },
    onUpdate({ elInput, component }) {
      onLinkTraitsUpdate(elInput, component, this.model);
    },
  });

  editor.on('component:selected', function () {
    // get the selected componnet and its default toolbar
    const componentModel = editor.getSelected();
    if (typeof componentModel !== 'undefined' && !Array.isArray(componentModel)) {
      const parentComponent = componentModel.closestType('data-group-external-api');
      if (parentComponent && parentComponent !== 'undefined') {
        if (textComponentsForJsonField.includes(componentModel.get('type'))) {
          if (!componentModel.getTrait('data-json-field')) {
            componentModel.addTrait({
              type: 'text',
              name: 'data-json-field',
              title: 'JSON Field Key',
              label: 'JSON Field Key',
              placeholder: 'Ex: user_id',
            });
          }
        } else if (linkComponentsForJsonField.includes(componentModel.get('type'))) {
          if (!componentModel.getTrait('data-link-json-field')) {
            componentModel.addTrait({
              type: 'text',
              name: 'data-link-json-field',
              title: 'JSON Field Key',
              label: 'JSON Field Key',
              placeholder: 'Ex: user_id',
            });
          }
        } else if (mediaComponentsForJsonField.includes(componentModel.get('type'))) {
          if (!componentModel.getTrait('data-media-json-field')) {
            componentModel.addTrait({
              type: 'text',
              name: 'data-media-json-field',
              title: 'JSON Field Key',
              label: 'JSON Field Key',
              placeholder: 'Ex: source_url',
            });
          }
        }
      } else {
        const allTraits = componentModel.get('traits');
        const removeTraits = [];
        allTraits.forEach((trait) => {
          if (trait.props().type === 'text' && trait.props().name === 'data-json-field') {
            removeTraits.push(trait.props().name);
          }
        });
        removeTraits.map((trait) => componentModel.removeTrait(trait));
      }
    }
  });

  editor.on('block:drag:stop', (componentModel, blockModel) => {
    if (typeof componentModel !== 'undefined' && !Array.isArray(componentModel)) {
      const parentComponent = componentModel.closestType('data-group-external-api');
      if (parentComponent && parentComponent !== 'undefined') {
        if (textComponentsForJsonField.includes(componentModel.get('type'))) {
          if (!componentModel.getTrait('data-json-field')) {
            componentModel.addTrait({
              type: 'text',
              name: 'data-json-field',
              title: 'JSON Field Key',
              label: 'JSON Field Key',
              placeholder: 'Ex: user_id',
            });
          }
        } else if (linkComponentsForJsonField.includes(componentModel.get('type'))) {
          if (!componentModel.getTrait('data-link-json-field')) {
            componentModel.addTrait({
              type: 'text',
              name: 'data-link-json-field',
              title: 'JSON Field Key',
              label: 'JSON Field Key',
              placeholder: 'Ex: user_id',
            });
          }
        } else if (mediaComponentsForJsonField.includes(componentModel.get('type'))) {
          if (!componentModel.getTrait('data-media-json-field')) {
            componentModel.addTrait({
              type: 'text',
              name: 'data-media-json-field',
              title: 'JSON Field Key',
              label: 'JSON Field Key',
              placeholder: 'Ex: source_url',
            });
          }
        }
      } else {
        const allTraits = componentModel.get('traits');
        const removeTraits = [];
        allTraits.forEach((trait) => {
          if (trait.props().type === 'text' && trait.props().name === 'data-json-field') {
            removeTraits.push(trait.props().name);
          }
        });
        removeTraits.map((trait) => componentModel.removeTrait(trait));
      }
    }
  });

  editor.on('component:drag:end', (componentModel) => {
    if (typeof componentModel.target !== 'undefined' && !Array.isArray(componentModel.target)) {
      const parentComponent = componentModel.target.closestType('data-group-external-api');
      if (parentComponent && parentComponent !== 'undefined') {
        if (textComponentsForJsonField.includes(componentModel.target.get('type'))) {
          if (!componentModel.target.getTrait('data-json-field')) {
            componentModel.target.addTrait({
              type: 'text',
              name: 'data-json-field',
              title: 'JSON Field Key',
              label: 'JSON Field Key',
              placeholder: 'Ex: user_id',
            });
          }
        } else if (linkComponentsForJsonField.includes(componentModel.target.get('type'))) {
          if (!componentModel.target.getTrait('data-link-json-field')) {
            componentModel.target.addTrait({
              type: 'text',
              name: 'data-link-json-field',
              title: 'JSON Field Key',
              label: 'JSON Field Key',
              placeholder: 'Ex: user_id',
            });
          }
        } else if (mediaComponentsForJsonField.includes(componentModel.target.get('type'))) {
          if (!componentModel.target.getTrait('data-media-json-field')) {
            componentModel.target.addTrait({
              type: 'text',
              name: 'data-media-json-field',
              title: 'JSON Field Key',
              label: 'JSON Field Key',
              placeholder: 'Ex: source_url',
            });
          }
        }
      } else {
        const allTraits = componentModel.target.get('traits');
        const removeTraits = [];
        allTraits.forEach((trait) => {
          if (trait.props().type === 'text' && trait.props().name === 'data-json-field') {
            removeTraits.push(trait.props().name);
          }
        });
        removeTraits.map((trait) => componentModel.target.removeTrait(trait));
      }
    }
  });
}

const onTraitsChange = (elInput, component, traits) => {
  const traitsFieldAttr = traits.get('name');
  console.log('traitsFieldAttrtraitsFieldAttr', traitsFieldAttr);
  const select = elInput.querySelector('.field-text-select');
  console.log('select *** :>> ', select);
  console.log('select.options *** :>> ', select.options);
  const checkbox = elInput.querySelector('input[name="getTextContent"]:checked');
  console.log('checkbox *** :>> ', checkbox);
  let selectFieldValue = select.value;
  console.log('selectFieldValue selectFieldValue->', selectFieldValue);
  if (selectFieldValue.includes("'")) {
    selectFieldValue = selectFieldValue.split("'").join('"');
    console.log('selectFieldValueselectFieldValue:::::::::', selectFieldValue);
  }
  const selectedOption = select.options[select.selectedIndex];
  const fieldType = selectedOption.getAttribute('type');
  console.log('fieldTypefieldTypefieldType', fieldType);
  console.log('selectFieldValue::', selectFieldValue, '--', checkbox);
  let attr = component.getAttributes();
  const id = attr.id;
  const imageSrc = attr.src;
  const compType = component.get('type');
  if (['input', 'select', 'checkbox', 'file-input'].includes(compType)) {
    delete attr['data-form-element-collection'];
    delete attr['data-form-element-session'];
  } else if (compType !== 'link') {
    attr = {};
    attr.id = id;
  }
  if (compType === 'bs-image') {
    attr.src = imageSrc;
  }
  if (checkbox && selectFieldValue) {
    attr[traitsFieldAttr] = selectFieldValue;
    if (ReferenceCreatedByFields.includes(fieldType)) {
      attr['metaData'] = selectedOption.getAttribute('metaData').split("'").join('"');
    } else {
      delete attr['metaData'];
    }
    if (fieldType) {
      attr['data-field-type'] = fieldType;
    } else {
      delete attr['data-field-type'];
    }
    attr['type'] = fieldType;
  }

  component.setAttributes(attr);
  if (traitsFieldAttr !== 'data-img-src' && traitsFieldAttr !== 'data-form-element-data-group') {
    console.log('-----------------------', component.el);
    component.set('content', '');
    component.set(
      'content',
      select.options[select.selectedIndex] ? select.options[select.selectedIndex].text : '',
    );
  }
  console.log(component);
};
const onTraitsUpdate = (elInput, component, traits) => {
  const traitOptions = traits.get('options') || [];
  const attr = component.getAttributes();
  let selectedValue = attr[traits.get('name')];
  if (selectedValue) {
    const select = elInput.querySelector('.field-text-select');
    let checkbox = elInput.querySelector('input[name="getTextContent"]');
    checkbox.checked = true;
    const selectFieldDiv = elInput.querySelector('#field-text-select-div');
    select.innerHTML = getFieldOptionsForSelect(traitOptions);
    console.log('on traits update:::', selectedValue);
    if (selectedValue.includes('"')) {
      selectedValue = selectedValue.split('"').join("'");
    }
    select.value = selectedValue;
    selectFieldDiv.style.display = 'block';
  } else {
  }
};

const onLinkTraitsChange = (elInput, component, traits) => {
  const traitsFieldAttr = traits.get('name');
  console.log('onLinkTraitsChange traitsFieldAttrtraitsFieldAttr', traitsFieldAttr);
  const select = elInput.querySelector('.field-url-select');
  console.log('select *** :>> ', select);
  const checkbox = elInput.querySelector('input[name="getURLFrom"]:checked');
  console.log('checkbox *** :>> ', checkbox);
  let selectFieldValue = select.value;
  if (selectFieldValue.includes("'")) {
    selectFieldValue = selectFieldValue.split("'").join('"');
  }
  console.log('onLinkTraitsChange selectFieldValue::', selectFieldValue, '--', checkbox);
  let attr = component.getAttributes();
  const id = attr.id;
  if (component.get('type') !== 'link') {
    attr = {};
    attr.id = id;
  }
  console.log('onLinkTraitsChange atttrrrrrrrrrrrr', attr, 'traitsFieldAttr::::', traitsFieldAttr);
  if (checkbox && selectFieldValue) {
    attr[traitsFieldAttr] = selectFieldValue;
  }
  component.setAttributes(attr);

  if (traitsFieldAttr !== 'data-img-src') {
    console.log('-----------------------', component.el);
    component.set('data-href-content', '');
    component.set(
      'data-href-content',
      select.options[select.selectedIndex] ? select.options[select.selectedIndex].text : '',
    );
  }
  console.log(component);
};
const onLinkTraitsUpdate = (elInput, component, traits) => {
  const traitOptions = traits.get('options') || [];
  const attr = component.getAttributes();
  let selectedValue = attr[traits.get('name')];
  if (selectedValue) {
    const select = elInput.querySelector('.field-url-select');
    let checkbox = elInput.querySelector('input[name="getURLFrom"]');
    checkbox.checked = true;
    const selectFieldDiv = elInput.querySelector('#field-url-select-div');
    select.innerHTML = getFieldOptionsForSelect(traitOptions);

    if (selectedValue.includes('"')) {
      selectedValue = selectedValue.split('"').join("'");
    }
    select.value = selectedValue;
    selectFieldDiv.style.display = 'block';
  } else {
  }
};
